module.exports = __webpack_public_path__ + "img/4.a949dba5.png";